import { AxiosRequest } from "../ApiCall";
import { configEnv } from "../constant";

export const googleApi = {
    /**
     * `/google/connect` is opened by a page navigation, which cannot carry the
     * Authorization header, so it used to be given the login token in the
     * query string, where browser history and access logs keep it. It now
     * takes a token minted here instead: valid for 60 seconds and for one
     * use, so mint it immediately before navigating.
     * @throws the axios error, so the caller can show its own message.
     */
    getConnectToken: async (header: any): Promise<string> => {
        const response = await AxiosRequest(
            "POST",
            `${configEnv.baseUrl}/google/connect-token`,
            {},
            header,
            // The connect modal reports a failure itself.
            { silentError: true }
        );
        const token = response?.data?.data?.token;
        if (!token) {
            throw new Error("Google connect token missing from response");
        }
        return token;
    },
    /** The URL that starts the Google consent flow for a minted connect token. */
    connectUrl: (connectToken: string): string =>
        `${configEnv.baseUrl}/google/connect?connect_token=${encodeURIComponent(
            connectToken
        )}`,
    googleOAuthCallback: async (code: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/google/callback?code=${code}`,
                null,
                header
            );
            return data;
        } catch (error: any) {
            throw error;
        }
    },
};
